import { Variable } from '@ff-scene-plugins/gift-shared/Variable';
import { svgToFfCanvas } from '@gift-variable-plugins/svg-shared/svgToFfCanvas';
import { SvgVariableInput } from '@gift-variable-plugins/svg-shared/SvgVariableInput';
import { SvgVariableOptions } from '@gift-variable-plugins/svg-shared/SvgVariableOptions';
import { SvgInputControl } from './SvgInputControl';

export const svgPdpPlugin: Variable.Plugin<SvgVariableOptions, SvgVariableInput> = {
    pluginId: 'svg',
    InputControl: SvgInputControl,
    toFfCanvas: svgToFfCanvas
};